import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import * as echarts from "echarts";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, onMounted, reactive, ref, onUnmounted } from "vue";
import { useStore } from "vuex";
import staticData from "@/assets/data/dataScreen.json";
export default defineComponent({
  name: "PartyPayIndex",
  components: {},
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var store = useStore();
    var Data = reactive({
      // 不同类型数据类型对应的单位
      option: {
        title: {//   text: "Awesome Chart",
        },
        legend: {
          show: false
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true
            }
          },
          formatter: function formatter(params) {
            return params;
          }
        },
        xAxis: {
          axisLine: {
            lineStyle: {
              color: "#9EA3B4",
              opacity: 0.3
            }
          },
          axisLabel: {
            textStyle: {
              color: "#4dbdff"
            }
          },
          data: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
        },
        yAxis: {
          splitLine: {
            show: false
          },
          name: "次数",
          nameTextStyle: {
            color: "#4dbdff",
            padding: [0, 40, 0, 0]
          },
          axisLabel: {
            textStyle: {
              color: "#4dbdff"
            }
          }
        },
        series: [{
          name: "折线图",
          type: "line",
          itemStyle: {
            normal: {
              color: "#f29664"
            }
          },
          data: [220, 182, 191, 234, 290, 330, 310, 220, 182, 191, 234, 290, 330, 310]
        }, {
          name: "柱状图",
          type: "bar",
          barWidth: 20,
          itemStyle: {
            normal: {
              barBorderRadius: 2,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 1,
                color: "#0772fd"
              }, {
                offset: 0,
                color: "#11c2ff"
              }])
            }
          },
          data: [220, 182, 191, 234, 290, 330, 310, 220, 182, 191, 234, 290, 330, 310]
        }]
      }
    });
    onMounted(function () {
      if (store.state.system.demonstration) {
        Data.option.series[0].data = staticData.trainData;
        Data.option.series[1].data = staticData.trainData;
        getMountEcherts();
      } else {
        getList();
        taskGetTrain();
      }
    });

    var getList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getTrainDataScreen();

              case 2:
                _context.next = 4;
                return getMountEcherts();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getList() {
        return _ref.apply(this, arguments);
      };
    }();

    var timer;

    var taskGetTrain = function taskGetTrain() {
      timer = setInterval(function () {
        getList(); // clearInterval(timer);
        // taskGetTrain();
      }, 10000);
    };

    onUnmounted(function () {
      clearInterval(timer);
    }); //党校培训

    var getTrainDataScreen = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getTrainDataScreen"]();

              case 2:
                res = _context2.sent;

                if (res.code == 0) {
                  Data.option.series[0].data = res.data;
                  Data.option.series[1].data = res.data;
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getTrainDataScreen() {
        return _ref2.apply(this, arguments);
      };
    }(); //挂载eCharts


    var myChart;
    var myChartRef = ref();

    var getMountEcherts = function getMountEcherts() {
      myChartRef.value = document.getElementById("trainMain");

      if (myChartRef.value) {
        myChart = echarts.init(myChartRef.value);
        myChart.setOption(Data.option);
      }
    };

    window.addEventListener('resize', function () {
      myChart.resize();
    });
    return {
      Data: Data,
      getMountEcherts: getMountEcherts,
      getList: getList,
      getTrainDataScreen: getTrainDataScreen
    };
  }
});